import React, { useEffect, useState, useCallback } from "react";
import Review from "./review";
import Loader from "../loader";

// emptyMessage: 0件のときの表示を出す画面だけ渡す（今はレビュー一覧＝画面65のみ。サークルページ60・イベント詳細は渡さない）
// scoredCount: 星を付けた評価の件数。感想の文章が無い評価は一覧に出ないので、0件の文言の出し分けに使う
const ReviewList = ({circleId, currentUser, isFormShow, digestPage = false, isCircleManager = false, emptyMessage = false, scoredCount = 0}) => {
  const [circlesReviews, setCirclesReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const loadReviews = useCallback(() => {
    $.ajax({
      url: "/api/circles_reviews",
      type: "GET",
      cache: false,
      data: {
        circle_id: circleId,
      },
    })
      .then((data) => {
          setCirclesReviews(digestPage ? data.circles_reviews.slice(0, 2) : data.circles_reviews);
          setLoading(false);
          setLoaded(true);
        },
      )
      .fail(() => {
          setLoading(false)
        },
      );
  }, []);

  useEffect(() => {
    loadReviews();
  }, [loadReviews]);

  const circlesReviewsList = circlesReviews.map((review) => {
    return (
      <div key={review.id}>
        {(review && (
          <Review
            review={review}
            currentUser={currentUser}
            isFormShow={isFormShow}
            isCircleManager={isCircleManager}
          />
        ))}
      </div>
    );
  });

  return (
    <div className="pl-2">
      <div id="comment-area">
        <div className="pt-3 pb-0">
          <ul className="list-unstyled mb-0">{circlesReviewsList}</ul>
          {/* 0件の表示。読み込みが終わって1件も無いときだけ出す（読み込み中・失敗時は出さない）。
              形はやることリスト（画面36）・アルバム（62・63）と同じ、グレーの丸に線のアイコン（画面65-1。デザイナー指示 2026-10-14） */}
          {emptyMessage && loaded && circlesReviews.length === 0 && (
            <div className="rv-empty">
              <span className="rv-empty__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </span>
              {scoredCount > 0 ? (
                <React.Fragment>
                  <p className="rv-empty__title">コメント付きのレビューはまだありません</p>
                  <p className="rv-empty__text">星評価のみ投稿されています</p>
                </React.Fragment>
              ) : (
                <p className="rv-empty__title">まだレビューはありません</p>
              )}
            </div>
          )}
        </div>
        <Loader isActive={loading} />
      </div>
    </div>
  );
};


export default ReviewList;
